import { render } from "./MemberBirthday.vue?vue&type=template&id=12915562&scoped=true"
import script from "./MemberBirthday.vue?vue&type=script&lang=js"
export * from "./MemberBirthday.vue?vue&type=script&lang=js"

import "./MemberBirthday.vue?vue&type=style&index=0&id=12915562&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12915562"]])

export default __exports__